module.exports = __webpack_public_path__ + "static/media/location_vector.fae6fff6.svg";